import { useSetAtom } from "jotai";
import { Activity, BarChart3 } from "lucide-react";
import { useCallback, useEffect } from "react";
import { useLocation } from "wouter";
import { appShell } from "@/store";

function ReportsPage() {
  const setBackButton = useSetAtom(appShell.backButtonAtom);
  const [, setLocation] = useLocation();

  useEffect(() => {
    setBackButton(false);
  }, [setBackButton]);

  const handleNavigateHistory = useCallback(() => {
    setLocation("/app/reports/irrigation-plan-history");
  }, [setLocation]);

  const handleNavigateExecutionReport = useCallback(() => {
    setLocation("/app/reports/irrigation-plan-execution-report");
  }, [setLocation]);

  const handleNavigateCodecTimeline = useCallback(() => {
    setLocation("/app/reports/codec-timeline");
  }, [setLocation]);
  return (
    <div className="min-h-full space-y-6 bg-gray-50 p-6 pb-20">
      <header className="space-y-1">
        <h1 className="text-2xl font-bold text-gray-900">Relatórios</h1>
        <p className="text-gray-600">Analise dados, identifique oportunidades e acompanhe indicadores.</p>
      </header>

      <section className="grid gap-4 md:grid-cols-2">
        <button
          type="button"
          onClick={handleNavigateHistory}
          className="group flex w-full flex-col rounded-2xl border border-neutral-200 bg-white p-5 text-left shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-2">
              <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600">
                Monitoramento
              </span>
              <h2 className="text-lg font-semibold text-gray-900">Histórico de planos de irrigação</h2>
              <p className="text-sm text-gray-600">
                Acompanhe eventos, mudanças de estado e métricas agregadas de planos e projetos.
              </p>
            </div>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 text-blue-600 transition group-hover:bg-blue-600 group-hover:text-white">
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </span>
          </div>
          <div className="mt-4 flex items-center justify-between text-sm font-medium text-blue-600">
            <span>Ver histórico</span>
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>

        <button
          type="button"
          onClick={handleNavigateExecutionReport}
          className="group flex w-full flex-col rounded-2xl border border-neutral-200 bg-white p-5 text-left shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-2">
              <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-600">
                Análise de Desempenho
              </span>
              <h2 className="text-lg font-semibold text-gray-900">Relatório de Execução de Planos</h2>
              <p className="text-sm text-gray-600">
                Analise o desempenho, status e problemas na execução dos planos de irrigação.
              </p>
            </div>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600 transition group-hover:bg-green-600 group-hover:text-white">
              <BarChart3 className="h-5 w-5" />
            </span>
          </div>
          <div className="mt-4 flex items-center justify-between text-sm font-medium text-green-600">
            <span>Ver relatório de execução</span>
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>

        <button
          type="button"
          onClick={handleNavigateCodecTimeline}
          className="group flex w-full flex-col rounded-2xl border border-neutral-200 bg-white p-5 text-left shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-2">
              <span className="inline-flex items-center rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-600">
                Diagnóstico
              </span>
              <h2 className="text-lg font-semibold text-gray-900">Linha do Tempo do CODEC</h2>
              <p className="text-sm text-gray-600">
                Eventos do dispositivo, comandos enviados e comunicação em uma única linha do tempo.
              </p>
            </div>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100 text-purple-600 transition group-hover:bg-purple-600 group-hover:text-white">
              <Activity className="h-5 w-5" />
            </span>
          </div>
          <div className="mt-4 flex items-center justify-between text-sm font-medium text-purple-600">
            <span>Ver linha do tempo</span>
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>
      </section>
    </div>
  );
}

export default ReportsPage;
